document.addEventListener('DOMContentLoaded', function() {
    // Product cards navigation (ignore clicks on any input)
    document.querySelectorAll('.product-card').forEach(function(card) {
        card.addEventListener('click', function(e) {
            if (e.target.closest('input, label, .filter-content')) return;
            const url = card.getAttribute('data-url');
            if (url) window.location.href = url;
        });
    });

    // View switcher
    document.querySelectorAll('.view-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            const grid = document.querySelector('.product-grid');
            grid.classList.remove('grid-3', 'grid-4', 'grid-list');
            grid.classList.add('grid-' + this.getAttribute('data-columns'));
        });
    });

    // Collapse/expand each filter
    document.querySelectorAll('.filter-header').forEach(function(header) {
        header.addEventListener('click', function(e) {
            // only toggle when clicking the header itself
            if (e.target.closest('.reset-link')) return;
            header.classList.toggle('active');
            const content = header.nextElementSibling;
            content.style.display = (content.style.display === 'block') ? 'none' : 'block';
        });
    });

    // Prevent clicks inside filter content from bubbling to header
    document.querySelectorAll('.filter-content').forEach(function(content) {
        content.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    // Auto-submit form on change
    const filterForm = document.getElementById('CollectionFiltersForm');
    if (filterForm) {
        filterForm.addEventListener('change', function(e) {
            const t = e.target;
            if (t.matches('input[type="checkbox"], input[type="number"]')) {
                filterForm.submit();
            }
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
  // get query params from URL
  const urlParams = new URLSearchParams(window.location.search);

  const minInput = document.getElementById("min-price-input");
  const maxInput = document.getElementById("max-price-input");

  if (urlParams.has(minInput.name)) {
    minInput.value = urlParams.get(minInput.name);
  }

  if (urlParams.has(maxInput.name)) {
    maxInput.value = urlParams.get(maxInput.name);
  }
});